import { useParams } from 'react-router-dom'

interface UrlParams {
  reservationNo: string
}

export const useAction = () => {
  const { reservationNo } = useParams<UrlParams>()

  return {
    reservationNo,
  }
}

//------------------------------------------------------------------------------------------
